import { Link } from 'react-router-dom';

const testimonials = [
  {
    initial: 'M',
    color: 'bg-primary-500',
    name: 'Redazione Itaobuy',
    handle: '@itaobuy_sheet',
    quote: 'Itaobuy spreadsheet ha trasformato il modo in cui gli utenti italiani affrontano lo shopping online. Organizzazione, chiarezza e velocit\u00e0: tre pilastri che rendono questa piattaforma indispensabile per chi cerca prodotti di qualit\u00e0 senza perdere tempo nella ricerca.',
  },
  {
    initial: 'L',
    color: 'bg-accent-500',
    name: 'Redazione Itaobuy',
    handle: '@itaobuy_sheet',
    quote: 'La community italiana di itaobuy sheet cresce ogni giorno. Migliaia di utenti trovano ogni settimana nuovi prodotti attraverso le nostre categorie organizzate. Lo spreadsheet \u00e8 diventato il punto di riferimento per lo shopping consapevole e informato.',
  },
  {
    initial: 'G',
    color: 'bg-secondary-600',
    name: 'Redazione Itaobuy',
    handle: '@itaobuy_sheet',
    quote: 'Con oltre 14 categorie e aggiornamenti costanti, itaobuy spreadsheet offre un\u2019esperienza di navigazione unica. Dalle sneakers agli accessori, ogni categoria \u00e8 curata nei minimi dettagli per garantire la migliore esperienza possibile.',
  },
  {
    initial: 'A',
    color: 'bg-primary-600',
    name: 'Redazione Itaobuy',
    handle: '@itaobuy_sheet',
    quote: 'La trasparenza \u00e8 il nostro valore fondamentale. Ogni link, ogni categoria, ogni suggerimento su itaobuy spreadsheet \u00e8 pensato per offrire agli utenti un percorso di acquisto chiaro, sicuro e senza sorprese.',
  },
  {
    initial: 'S',
    color: 'bg-accent-600',
    name: 'Redazione Itaobuy',
    handle: '@itaobuy_sheet',
    quote: 'Il 2026 segna un nuovo capitolo per itaobuy spreadsheet. Nuove categorie, guide complete e una knowledge base in continua espansione per supportare ogni tipo di acquirente, dal principiante all\u2019esperto.',
  },
  {
    initial: 'E',
    color: 'bg-secondary-500',
    name: 'Redazione Itaobuy',
    handle: '@itaobuy_sheet',
    quote: 'La sicurezza degli acquisti \u00e8 la nostra priorit\u00e0. Con itaobuy spreadsheet, ogni utente pu\u00f2 navigare tra le categorie nella massima tranquillit\u00e0, sapendo di avere accesso a informazioni verificate e costantemente aggiornate.',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-14 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300/40 text-xs font-medium text-primary-700 mb-6">
            Community
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Recensioni &amp; Casi Studio
          </h2>
          <p className="font-heading text-4xl md:text-5xl text-foreground-400 font-light italic mt-1">
            Itaobuy Spreadsheet
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 md:gap-6 space-y-5 md:space-y-6">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="break-inside-avoid bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              {/* Author */}
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full ${item.color} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-white font-semibold text-sm">{item.initial}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.handle}</p>
                </div>
              </div>

              {/* Quote */}
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{item.quote}&rdquo;
              </p>
            </div>
          ))}

          {/* SEO Article Card */}
          <div className="break-inside-avoid bg-primary-500 rounded-xl p-5 md:p-6 border border-primary-400">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-article-line text-white text-lg w-5 h-5 flex items-center justify-center"></i>
              <span className="text-xs font-semibold text-white/80 uppercase tracking-wider">Articolo SEO</span>
            </div>
            <h3 className="font-heading text-lg font-semibold text-white mb-3 leading-snug">
              Guida Completa: Itaobuy Spreadsheet Come Funziona
            </h3>
            <p className="text-sm text-white/80 leading-relaxed mb-4">
              Tutto ci&ograve; che devi sapere su itaobuy spreadsheet in un&apos;unica guida approfondita. Dalla configurazione iniziale alle strategie avanzate, passando per sicurezza, confronto categorie e consigli pratici.
            </p>
            <div className="flex flex-col gap-2">
              <Link
                to="/confronto-categorie"
                className="inline-flex items-center justify-center w-full py-2.5 rounded-full bg-white text-primary-600 font-semibold text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line mr-2 text-base"></i>
                Confronta le Categorie
              </Link>
              <Link
                to="/"
                className="text-xs text-white/60 hover:text-white transition-colors duration-200 text-center"
              >
                &larr; Torna alla Home di itaobuyspread.store
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}